import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IconButton as MDIconButton } from "@material-ui/core";
import React from "react";
import { twMerge } from "tailwind-merge";
import { ButtonBaseProps, appearances } from "./common";

type IconButtonProps = Omit<
  ButtonBaseProps,
  "startIcon" | "endIcon" | "appearance" | "size"
> & {
  loadingClassName?: string;
  size?: "small" | "medium";
};

export const IconButton = ({
  children,
  className,
  status = "default",
  loadingClassName,
  onClick,
  type,
  size,
}: IconButtonProps): React.ReactElement => {
  return (
    <MDIconButton
      size={size}
      onClick={onClick}
      type={type}
      disabled={status === "default" ? false : true}
      className={twMerge(
        appearances["icon"][0],
        appearances["icon"][1][status],
        "items-center justify-center border font-medium transition-colors",
        className
      )}
    >
      {status === "loading" ? (
        <AiOutlineLoading3Quarters
          className={twMerge(
            "m-0 h-4 w-4 animate-spin p-0 text-white",
            loadingClassName
          )}
        />
      ) : (
        children
      )}
    </MDIconButton>
  );
};
